import React from "react";
import PropTypes from "prop-types";

// COMPONENTS
import StackLayout from "@components/layouts/StackLayout/StackLayout";

// HELPERS
import {createClassName} from "@helpers/utils";

export default class CobStart extends React.PureComponent {

	static propTypes = {
		onLookupDataLoaded: PropTypes.func.isRequired,
	};

	state = _getInitialState.call(this);

	render() {
		const {props} = this;
		const {app} = props;
		const {partner} = app;
		const classes = createClassName("Cob-Start", {});

		return (
			<div className={classes}>
				<StackLayout orientation="vertical" fullWidth>
					<h1>{partner.welcomeTitle}</h1>

					{partner.welcomeSubtitle && (
						<h2>{partner.welcomeSubtitle}</h2>
					)}

					<p className={"intro"} style={{marginTop: "20px"}}>
						Den här funktionen går enbart att komma åt via rådgivingsapplikationen. 
					</p>

				</StackLayout>
			</div>
		);
	}
}

// PRIVATE FUNCTIONS
function _getInitialState() {
	return {
		hidden: true,
		busy: false,
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Start/restricted/Start.js